//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum } from '@shared/Enums'

import { logOT } from '@shared/loggingShared'

import { PoolAbi, PoolAccessControlAbi } from '@shared/Abis'
import { ProviderWritable } from '@shared/SchemaTypes'

import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'

export async function allowPoolParticipation(
  webSocket: WebSocket | undefined,

  poolAdminSigner: Signer,
  poolAddr: EthAddr,
  lenderAddr: EthAddr,
  chainConfigurationName: string
): Promise<boolean> {
  const uuid = txUUID()

  logOT.info('allowPoolParticipation 1', !!webSocket, poolAddr, lenderAddr)
  webSocket?.send(
    wsServerActionPoolTXRequest(ActivityEnum.POOL_ALLOW_PARTICIPATION, poolAddr, uuid, chainConfigurationName)
  )
  const providerWritable = poolAdminSigner.provider as ProviderWritable
  const PoolContract = new Contract(poolAddr, PoolAbi, providerWritable)
  const poolAccessControlAddr = await PoolContract.poolAccessControl()

  logOT.info('allowPoolParticipation 1/1', !!webSocket, poolAccessControlAddr, lenderAddr)
  const poolAccessControl = new Contract(poolAccessControlAddr, PoolAccessControlAbi, poolAdminSigner)

  const tx2 = await poolAccessControl.allowParticipant(lenderAddr)
  logOT.info('SEND allowPoolParticipation 2', !!webSocket, poolAddr, lenderAddr)
  logOT.info('allowPoolParticipation', !!webSocket, tx2.hash)

  webSocket?.send(
    wsServerActionPoolTX(
      ActivityEnum.POOL_ALLOW_PARTICIPATION,
      poolAddr,
      uuid,
      tx2.hash as TxHash,
      chainConfigurationName,
      { lenderAddr }
    )
  )
  await tx2.wait()

  const isAllowed = await poolAccessControl.isAllowed(lenderAddr)
  logOT.info('allowPoolParticipation', isAllowed)

  logOT.info('allowPoolParticipation 3', !!webSocket, poolAddr, lenderAddr, isAllowed)
  return isAllowed
}
